<template>
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill="#6F4FCC" fill-opacity="0.2"/>
        <circle cx="30.0039" cy="30.0039" r="22" fill="url(#paint0_linear_6987_189215)"/>
        <path d="M24.4453 28.8906V24.4462C24.4453 22.9728 25.0306 21.5597 26.0725 20.5178C27.1144 19.4759 28.5274 18.8906 30.0009 18.8906C31.4743 18.8906 32.8874 19.4759 33.9292 20.5178C34.9711 21.5597 35.5564 22.9728 35.5564 24.4462V28.8906" stroke="#E3DCF7" stroke-width="1.88889" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M37.7778 28.8906H22.2222C20.9949 28.8906 20 29.8855 20 31.1128V38.8906C20 40.1179 20.9949 41.1128 22.2222 41.1128H37.7778C39.0051 41.1128 40 40.1179 40 38.8906V31.1128C40 29.8855 39.0051 28.8906 37.7778 28.8906Z" stroke="#E3DCF7" stroke-width="1.88889" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
            <linearGradient id="paint0_linear_6987_189215" x1="30.0039" y1="8.00391" x2="30.0039" y2="52.0039" gradientUnits="userSpaceOnUse">
                <stop stop-color="#6342C5"/>
                <stop offset="1" stop-color="#8563E9"/>
            </linearGradient>
        </defs>
    </svg>
</template>
